<template>
  <section class="aboutme" id="aboutme">
    <div class="wrapper">
      <div class="me">
        <h2>My Background</h2>
        <p>I've spent ten years at bet365, moving from customer support through operations and compliance, into UI/UX design, and now front-end development.</p>
        <p>As a UI Developer, I build production user interfaces across web, iOS and Android. I take new features from design through to release, working closely with designers, developers and analysts while keeping brand consistency and code quality high across platforms.</p>
        <p>Before moving into development I spent three years as a UI/UX Analyst, documenting design specifications, creating HTML/CSS and iOS prototypes, producing optimised assets in Photoshop, Illustrator and Sketch, and conducting design QA and cross-device testing. That grounding in how users actually experience an interface still shapes how I build them.</p>
        <p>Outside of work I develop iOS apps in Swift and SwiftUI. My current project, Chi, is a health &amp; fitness app for iPhone and Apple Watch that scores sleep, recovery, and training strain entirely on-device.</p>
      </div>
      <aside>
        <h2>Skills</h2>
        <ul>
          <li>Swift &amp; SwiftUI</li>
          <li>HealthKit, watchOS &amp; WidgetKit</li>
          <li>HTML5, CSS3 &amp; JavaScript</li>
          <li>React &amp; Vue.js</li>
          <li>Sketch, Photoshop &amp; Illustrator</li>
          <li>Design QA &amp; cross-device testing</li>
          <li>Git &amp; JIRA</li>
        </ul>
      </aside>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutMe',
};
</script>
